<fa-icon
    class="w-5 h-5"
    [class.text-black]="isTextBlack()"
    [class.text-custom-dark-grey]="isTextDisabledColor()"
    [icon]="icon()"
    [matTooltip]="tooltip()"
    [style.cursor]="cursor()"
    (click)="onClick($event)" />
